<template>
  <div class="searchresult-wrap" @touchmove="move">
    <div class="statebar" :style="{height:barh/100+'rem'}"></div>
    <div class="head" :style="{top:barh/100+'rem'}">
      <img src="@/assets/images/ios/search/back.png" alt @click="returnpage" />
      <div class="inputbox">
        <img class="sousuo" src="@/assets/images/ios/search/search.png" v-show="keyword==''" />
        <input
          ref="input"
          type="text"
          placeholder="搜索更多好游戏"
          @input="getvalue($event)"
          @keypress="keypress($event)"
          :value="keyword"
          :class="keyword==''?'':'input'"
        />
      </div>
      <span @click="getlist">搜索</span>
    </div>
    <div class="loading" v-show="!isloading">
      <img src="@/assets/images/ios/search/loading.gif" alt />
    </div>
    <div
      class="box"
      :style="{marginTop:barh/100+0.44+'rem'}"
      v-show="isloading && gamelist.length==0"
    >
      <p class="box-keyword">
        没有找到“
        <span>{{val}}</span>”
      </p>
      <p class="box-dec">已将您的搜索词告知小编</p>
    </div>
    <div
      class="games"
      :style="{marginTop:barh/100+0.44+'rem'}"
      v-show="isloading && gamelist.length>0"
    >
      <gameli v-for="(item,ind) in gamelist" :key="ind" :game="item" :uuid="uuid"></gameli>
    </div>
  </div>
</template>

 <script>
import gameli from "@/components/ios/gameli.vue";
import { zoom, getUrlParam } from "@/utils/base";
import config from "@/../config";
export default {
  data() {
    return {
      barh: "20",
      keyword: "", //这个是搜索的关键字
      gamelist: [], //游戏列表
      uuid: "",
      val: "null",
      isloading: false //展示loading图
    };
  },
  components: {
    gameli
  },
  created() {
    this.keyword = decodeURI(this.$route.query.keyword);
    this.val = decodeURI(this.$route.query.keyword);
  },
  mounted() {
    //获取参数
    window.webkit.messageHandlers.getIosData.postMessage("");
    window["getUserInfo"] = data => {
      var userInfo = JSON.parse(data);
      this.uuid = userInfo.uuId;
      this.getlist();
    };
    //让客户端隐藏导航栏
    window.webkit.messageHandlers.hiddenNavigation.postMessage("");
    window["getConfigInfo"] = data => {
      this.barh = JSON.parse(data).statusBarHeight;
      var body = document.querySelector("body");
      var html = document.querySelector("html");
      var wrap = document.querySelector(".searchresult-wrap");
      var box = document.querySelector(".box");
      var games = document.querySelector(".games");
      box.style.height = (html.offsetHeight - this.barh - 44) / 100 + "rem";
      games.style.height = (html.offsetHeight - this.barh - 44) / 100 + "rem";
      // wrap.style.height = (html.offsetHeight - this.barh - 44) / 100 + "rem";
      body.style.height = (html.offsetHeight - this.barh - 44) / 100 + "rem";
    };
    window.webkit.messageHandlers.getConfigInfo.postMessage("");
    zoom();
  },
  methods: {
    move() {
      this.$refs.input.blur();
    },
    getvalue(event) {
      this.keyword = event.target.value;
    },
    // 按下enter键进行搜索
    keypress(event) {
      if (event.keyCode == 13) {
        this.getlist();
      }
    },
    push(params = {}, type = "") {
      let url = `${config.SERVER_TEMP}/gameserv/GameDetail/detail.html`;
      const queryParams = getUrlParam();
      params = queryParams ? { ...queryParams, ...params } : params;
      const keys = Object.keys(params);
      if (keys.length) {
        let str = "?";
        keys.forEach(key => {
          str += `${key}=${params[key]}&`;
        });
        url += str.substr(0, str.length - 1);
      }
      window.location.href = url;
    },
    jumpdetail(game) {
      collect("event_search_result_jump", { keyword: this.keyword });
      this.push({ gameId: game.id, keyword: this.keyword }, "ssr");
    },
    //获取input的值
    keywordinput(event) {
      this.keyword = event.target.value;
    },
    // 获取展示数据
    getlist() {
      this.isloading = true;
      if (!this.keyword) {
        return;
      }
      var list = localStorage.getItem("ios_history")
        ? JSON.parse(localStorage.getItem("ios_history"))
        : []; //本地存储的数据
      for (var i = 0; i < list.length; i++) {
        if (list[i].keyword === this.keyword) {
          list.splice(i, 1);
        }
      }
      list.unshift({
        keyword: this.keyword
      });
      localStorage.setItem("ios_history", JSON.stringify(list));
      this.$http
        .get(
          `/apiserv/qTLN2Nec/Backend/search/ios/search?gameName=${this.keyword}&uuid=${this.uuid}`
        )
        .then(res => {
          if (res.data.return_code == 200) {
            this.isloading = true;
            this.gamelist = res.data.data;
            this.val = this.keyword;
          }
        });
    },
    // 点击返回按钮
    returnpage() {
      // webview 调用客户端的返回
      window.webkit.messageHandlers.webNavigationBack.postMessage("");
    }
  }
};
</script>
<style scoped  lang="less">
.statebar {
  position: fixed;
  top: 0;
  width: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 115, 0, 1) 0%,
    rgba(255, 79, 0, 1) 100%
  );
  z-index: 10;
}
.searchresult-wrap {
  width: 100%;
  overflow-x: hidden;
  // overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  position: relative;
  box-sizing: border-box;
  // border-top: 0.1px solid #fff;
  .head {
    width: 100%;
    height: 0.44rem;
    position: fixed;
    left: 0;
    background: linear-gradient(
      90deg,
      rgba(255, 115, 0, 1) 0%,
      rgba(255, 79, 0, 1) 100%
    );
    display: flex;
    z-index: 10;
    img {
      width: 0.25rem;
      height: 0.25rem;
      margin-left: 0.09rem;
      margin-top: 0.08rem;
    }
    .inputbox {
      width: 2.66rem;
      height: 0.35rem;
      margin-left: 0.08rem;
      margin-top: 0.04rem;
      border: 0;
      border-radius: 0.19rem;
      box-sizing: border-box;
      display: flex;
      background: #ffffff;
      justify-items: center;
      overflow: hidden;
      img {
        width: 0.2rem;
        height: 0.2rem;
        display: block;
        margin-right: 0.1rem;
        margin-top: 0.07rem;
        line-height: 0.2rem;
      }
      .input {
        width: 100%;
        line-height: 0.35rem;
        margin-left: 0.19rem;
        margin-right: 0.19rem;
      }
      input {
        border: 0;
        font-size: 0.17rem;
        box-sizing: border-box;
        outline: none;
        font-weight: 400;
        color: #333333;
      }
    }
    span {
      font-size: 0.17rem;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 0.44rem;
      margin-left: 0.17rem;
    }
  }
  .loading {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
  }
  .box {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .box-keyword {
      font-size: 0.19rem;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 0.21rem;
      span {
        color: #df621a;
        font-size: 0.2rem;
      }
    }
    .box-dec {
      font-size: 0.15rem;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 0.21rem;
      margin-top: 0.04rem;
    }
  }
  .label {
    width: 100%;
    height: auto;
    padding: 0 0.17rem;
    background: #fff;
    margin-top: 0.5rem;
    .special {
      .findmore {
        width: 100%;
        height: 0.46rem;
        display: flex;
        justify-content: center;
        align-items: center;
        span {
          color: #999999;
          font-size: 0.15rem;
        }
        img {
          width: 0.13rem;
          height: 0.07rem;
          margin-left: 0.08rem;
        }
      }
    }
  }
  .games {
    width: 100%;
    height: auto;
    background: #fff;
    border-top: 1px solid #fff;
    padding: 0.12rem;
  }
}
</style>
